const DoctIcon = ({ iconColor }) => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1050_8413)">
        <rect width="56" height="56" rx="12" fill="#F2F3F5" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.9011 33.8537H31.0826C31.6238 33.8537 32.0727 33.4003 32.0727 32.8537C32.0727 32.307 31.6238 31.867 31.0826 31.867H23.9011C23.3598 31.867 22.911 32.307 22.911 32.8537C22.911 33.4003 23.3598 33.8537 23.9011 33.8537ZM28.3631 25.2003H23.9011C23.3598 25.2003 22.911 25.6537 22.911 26.2003C22.911 26.747 23.3598 27.187 23.9011 27.187H28.3631C28.9044 27.187 29.3532 26.747 29.3532 26.2003C29.3532 25.6537 28.9044 25.2003 28.3631 25.2003ZM37.7842 24.0345C38.0945 24.0309 38.4324 24.027 38.7394 24.027C39.0694 24.027 39.3334 24.2937 39.3334 24.627V35.347C39.3334 38.6537 36.6799 41.3337 33.406 41.3337H22.8978C19.4654 41.3337 16.6667 38.5203 16.6667 35.0537V20.6803C16.6667 17.3737 19.3334 14.667 22.6205 14.667H29.67C30.0133 14.667 30.2773 14.947 30.2773 15.2803V19.5737C30.2773 22.0137 32.2707 24.0137 34.6865 24.027C35.2508 24.027 35.7483 24.0312 36.1837 24.0349C36.5224 24.0378 36.8235 24.0403 37.0892 24.0403C37.2771 24.0403 37.5207 24.0375 37.7842 24.0345ZM38.1482 22.0883C37.0631 22.0923 35.7838 22.0883 34.8637 22.079C33.4036 22.079 32.201 20.8643 32.201 19.3897V15.875C32.201 15.3003 32.8914 15.015 33.2862 15.4297C34.0007 16.18 34.9826 17.2115 35.96 18.2383C36.9347 19.2622 37.9049 20.2813 38.601 21.0123C38.9865 21.4163 38.704 22.087 38.1482 22.0883Z"
          fill="#949497"
        />
      </g>
      <rect x="0.5" y="0.5" width="55" height="55" rx="11.5" stroke="#D7D7D8" />
      <defs>
        <clipPath id="clip0_1050_8413">
          <rect width="56" height="56" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DoctIcon;
